import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { reportsService } from '../services/api';
import { SalesReportResult } from '../types/reports';

export interface UseSalesReportFilters {
  dataInicio?: string;
  dataFim?: string;
  status?: string[];
  canais?: string[];
  formasPagamento?: string[];
  cliente?: string;
  telefone?: string;
  cnpj?: string;
}

export const useSalesReport = (filters: UseSalesReportFilters, enabled = true) => {
  const queryParams = useMemo(() => {
    return {
      dataInicio: filters.dataInicio,
      dataFim: filters.dataFim,
      status: filters.status,
      canais: filters.canais,
      formasPagamento: filters.formasPagamento,
      cliente: filters.cliente,
      telefone: filters.telefone,
      cnpj: filters.cnpj,
    };
  }, [filters]);

  return useQuery<SalesReportResult, Error>({
    queryKey: ['sales-report', queryParams],
    queryFn: () => reportsService.getSalesReport(queryParams),
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};
